module.exports = __webpack_public_path__ + "img/remove--red.e04ef4e2.svg";